// Version : 1.0.0
// Author : AGALYA
import { takeLatest, put, all, call } from 'redux-saga/effects';
import DrivingLicenceActionType from './driving-licence-details.types';
import {
	updateDrivingLicenceSuccess,
	updateDrivingLicenceFailure,
	updateDrivingLicenceResponseChanged,
} from './driving-licence-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { drivingLicenceUpdate } from './driving-licence-details.service';

/** ***************** UPDATE DRIVING LICENCE SAGA START *********************** */
export function* updateDrivingLicenceId({ payload }: any) {
	try {
		const key = 'updateDrivingLicenceID';
		const {
			companyID,
			databaseName,
			memberID,
			drivingLicenceFrontImg,
			drivingLicenceBackImg,
			proofType,
			docType,
			userID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			DrivingLicenceFrontImg: drivingLicenceFrontImg,
			DrivingLicenceBackImg: drivingLicenceBackImg,
			ProofType: proofType,
			DocumantType: docType,
			OfficerID: userID,
			Secratekey: key,
		};

		const rationCardData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(drivingLicenceUpdate, rationCardData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateDrivingLicenceFailure(responseData.data));
		} else {
			yield put(updateDrivingLicenceSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateDrivingLicenceFailure(error));
	}
}

export function* updateDrivingLicenceResponseClear() {
	yield put(updateDrivingLicenceResponseChanged());
}

export function* onDrivingLicenceUpdateStart() {
	yield takeLatest(DrivingLicenceActionType.UPDATE_DRIVING_LICENCE_START, updateDrivingLicenceId);
}

export function* onDrivingLicenceUpdateResponseRest() {
	yield takeLatest(
		DrivingLicenceActionType.UPDATE_DRIVING_LICENCE_RESPONSE_REST_START,
		updateDrivingLicenceResponseClear,
	);
}
/** ***************** UPDATE DRIVING LICENCE SAGA END *********************** */

export function* drivingLicenceSaga() {
	yield all([call(onDrivingLicenceUpdateStart), call(onDrivingLicenceUpdateResponseRest)]);
}
